import { useCallback } from 'react';

export interface MouseMoveHandlerProps {
  drag: React.MutableRefObject<boolean>;
  blockRef: React.MutableRefObject<HTMLDivElement | null>;
  startX: React.MutableRefObject<number>;
  scrollLeft: React.MutableRefObject<number>;
}

export const useMouseMoveHandler = ({ drag, blockRef, startX, scrollLeft }: MouseMoveHandlerProps) =>
  useCallback((e: MouseEvent) => {
    if (drag.current) {
      e.preventDefault();

      const x = e.pageX - blockRef.current!.offsetLeft;
      const walk = (x - startX.current) * 1;

      blockRef.current!.scrollLeft = scrollLeft.current - walk;
    }
  }, []);
